import React, { useEffect, useState } from "react";
import { Tag } from "primereact/tag";
import { DataTable } from "primereact/datatable";
import moment from "moment";
import { Column } from "primereact/column";
import Spinner from "../../components/spinner";
import useDebounce from "../../components/hooks/useDebounce";
import { axiosApi } from "../../../services/axios_api";
import PaginatorComponent from "../../components/paginator";
import { toast } from "react-toastify";
import Dots from "../../../../assets/assests/detail.png";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import Details from "./details_transaction";
import { exportToExcel, renderTextWithTooltip } from "../../components/helper";

const TransactionReport = ({ globalFilter, exportCSV, fromDate, toDate }) => {
  const [loading, setLoading] = useState(false);
  const [filteredList, setFilteredList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
 const [rowselect, setRowselect] = useState(null);
  const [showdetail, setShowdetail] = useState(false);
  const debouncedSearch = useDebounce(globalFilter, 500);

  const getReportData = async (pageNumber = 1, pageSize = rows) => {
    setLoading(true);
    try {
      const response = await axiosApi.get(
        `/Portal/transactions/get-all-paginated`,
        {
          params: {
            pageNumber,
            pageSize,
            searchTerm: debouncedSearch || "",
            fromDate: fromDate ? moment(fromDate).format("YYYY-MM-DD") : null,
            toDate: toDate ? moment(toDate).format("YYYY-MM-DD") : null,
          },
        }
      );
      setFilteredList(response.data.body);
      setTotalRecords(response.data.totalRecords);
    } catch (error) {
      toast.error("Failed to fetch data.");
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (event) => {
    const { first, rows } = event;
    setFirst(first);
    setRows(rows);
    const pageNumber = first / rows + 1;
    getReportData(pageNumber, rows);
  };

  useEffect(() => {
    getReportData();
  }, [debouncedSearch, fromDate, toDate]);
  const showDetails = (rowData) => {
    setRowselect(rowData);
    setShowdetail(true);
  }


  const actionTemplate = (rowData) => {
    return (
      <div className="action-buttons">
       
        <Button className="p-button-edit p-0 mr-3" onClick={() => showDetails(rowData)}>
          <img src={Dots} alt="Details" />
        </Button>

      </div>
    );
  };
  const columnsData = [
    {
      field: "transactionId",
      header: "transaction Id",
      body: (rowData) => rowData.transactionId || "--",
    },
    {
      field: "kioskName",
      header: "kiosk Name",
      body: (rowData) => renderTextWithTooltip(rowData, "kioskName", "bottom"),
    },
    {
      field: "customerName",
      header: "customer Name",
      body: (rowData) => renderTextWithTooltip(rowData, "customerName", "bottom"),
    },
    {
      field: "recipientMobileNumber",
      header: "recipient Mobile Number ",
      body: (rowData) => rowData.recipientMobileNumber || "--",
    },
    {
      field: "serviceFee",
      header: "service Fee",
      body: (rowData) => rowData.serviceFee || "--",
    },
    {
      field: "amount",
      header: "amount",
      body: (rowData) => rowData.amount || "--",
    },
    {
          field: "status",
          header: "status",
          body: (rowData) => (
            <Tag
              className={
                rowData.status === "Completed"
                  ? "custom-success-tag"
                  : "custom-danger-tag"
              }
              value={rowData.status ?? "--"}
            />
          ),
        },
    {
      field: "completionDateTime",
      header: "completion Date Time",
      body: (rowData) =>
        rowData.completionDateTime
          ? moment(rowData.completionDateTime).format("YYYY-MM-DD HH:mm:ss")
          : "--",
    },
    {
      header: "Action",
      body: actionTemplate,
    },
  ];

 

  const exportCSVHandler = async () => {
    setLoading(true);
    try {
      const response = await axiosApi.get(
        `/Portal/transactions/get-all-paginated`
      );
      exportToExcel(response.data.body, columnsData, "TransactionData");
    } catch (error) {
      toast.error("Failed to export data.");
      console.error("Export Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (exportCSV) {
      exportCSV.current = exportCSVHandler;
    }
  }, []);

  return (
    <>
       <Dialog
        visible={showdetail}
        onHide={() => setShowdetail(false)}
        header="Transaction Report Details"
       className="dialog-size"
      >
        <Details
                  rowData={ rowselect } />
      </Dialog>
      {loading && (
        <div className="spinner-overlay">
          <Spinner />
        </div>
      )}

      <div className="card card-container">
        <DataTable
          emptyMessage="No record found."
          value={filteredList}
          className="custom-data-table"
          scrollable
          globalFilter={globalFilter}
        >
          {columnsData.map((data, index) => (
            <Column
              key={index}
              field={data.field}
              header={data.header}
              body={data.body}
              frozen={data.frozen}
            />
          ))}
        </DataTable>
        {totalRecords > 0 && (
          <PaginatorComponent
            first={first}
            rows={rows}
            totalRecords={totalRecords}
            onPageChange={handlePageChange}
          />
        )}
      </div>
    </>
  );
};

export default TransactionReport;
